<template>
	<GBRightPane
		v-bind:display="display"
		v-on:close="onClose"
	>
		<GBModalVScrollable class="project-select"
			title="案件選択"
			header_height="115"
			v-bind:bottom_height="bottomHeight"
			v-bind:bottom_value="show_selected"
			v-on:close="onClose"
		>
			<template v-slot:header>
				<v-layout row class="modal-header-filter">
					<v-flex xs10 class="mx-2">
						<v-text-field dark clearable height="23" v-model="filter_name" placeholder="名前で検索" color="white" single-line></v-text-field>
					</v-flex>
				</v-layout>
			</template>
			<template v-if="display">
				<GBProjectListRow
					v-for="item in filtered_project"
					v-bind:key="item.code"
					v-bind:item="item"
					v-bind:selectedProject="value"
					v-on:change-select-project="changeSelectProject"
					ref="project"
				/>
			</template>
			<template v-slot:bottom>
				<div class="project-item-group">
					<div 
						class="project-item d-inline-block"
						v-for="p in value"
						v-bind:key="p.code"
						v-bind:data-code="p.code"
					>
						<div class="project-item-name">
							<span>{{ p.name }}</span>
						</div>
						<v-btn fab flat 
							class="project-item-btn"
							v-on:click="onClickDeleteProject(p.code)">
							<v-icon>close</v-icon>
						</v-btn>
					</div>
				</div>
			</template>
		</GBModalVScrollable>
	</GBRightPane>
</template>
<script>
import GBRightPane from './GBRightPane';
import GBModalVScrollable from './GBModalVScrollable';
import GBProjectListRow from './GBProjectListRow';
import Util from '../classes/Util';

const BOTTOM_HEIGHT = 165;

export default {
	name: 'GBRightPaneProjectSelect',
	props: [
		"value",
	],
	components: {
		GBRightPane,
		GBModalVScrollable,
		GBProjectListRow,
	},
	data: function() {
		return {
			filter_name: '',
		};
	},
	methods: {
		onClose: function() {
			this.filter_name = '';
			this.$emit('close');
		},
		changeSelectProject: function(e) {
			if(e.select) {
				this.value.push({
					code: e.item.code,
					name: e.item.name,
				});
			} else {
				for(let i = 0; i < this.value.length; i++) {
					if(this.value[i].code === e.item.code) {
						this.value.splice(i, 1);
					}
				}
			}
		},
		onClickDeleteProject: function(code) {
			for(let i = 0; i < this.value.length; i++) {
				if(this.value[i].code === code) {
					this.value.splice(i, 1);
				}
			}
		},
	},
	computed: {
		display: function() {
			return this.value !== undefined && this.value !== null;
		},
		filtered_project: function() {
			let projects = this.$store.getters.projectList;
			if (projects == null)
				return;
			return projects.filter((item) => {
				if (this.filter_name === null)
					return true;
				if (this.filter_name.length === 0)
					return true;
				return item.name.search(Util.replaceEscapeString(this.filter_name)) >= 0;
			});
		},
		show_selected: function() {
			if(!this.value)
				return ;
			return this.value.length > 0;
		},
		bottomHeight: function() {
			if(this.show_selected)
				return BOTTOM_HEIGHT;
			return 0;
		},
	},
}
</script>
<style>
	.modal-window.project-select .modal-header-prolect-select {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.modal-window.project-select .project-item-group {
		margin: 10px 18px 10px 10px;
	}
	.modal-window.project-select .project-item {
		position: relative;
		border: solid 1px;
		background-color: #ffffff;
		border-radius: 20px;
		font-size: 12px;
		height: 30px;
		padding-right: 28px;
		margin: 5px;
	}
	.modal-window.project-select .project-item-name {
		display: flex;
		align-items: center;
		position: relative;
		top: -1px;
		left: -1px;
		border-radius: 20px 0px 0px 20px;
		height: 30px;
		padding: 0px 10px;
		cursor: pointer;
		user-select: none;
	}
	.modal-window.project-select .project-item-name span {
		overflow: hidden;
		height: 1.5em;
	}
	.modal-window.project-select .project-item-btn {
		position: absolute;
		border-radius: 0px 20px 20px 0px;
		top: -1px;
		right: -1px;
		height: 30px;
		width: 30px;
		margin: 0px;
	}
</style>
<style scoped>
	.v-btn--floating {
		position: absolute;
		right: -6px;
		top: -6px;
		opacity: 1;
	}

	.v-btn--floating.v-btn--small {
		width: 16px;
		height: 16px;
	}
</style>
